// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_changeset_trigger_enum */
var FermentationChangesetTriggerEnum;
(function (FermentationChangesetTriggerEnum) {
    FermentationChangesetTriggerEnum["now"] = "now";
    FermentationChangesetTriggerEnum["elapsed"] = "elapsed";
    FermentationChangesetTriggerEnum["at"] = "at";
})(FermentationChangesetTriggerEnum || (FermentationChangesetTriggerEnum = {}));
;
export default FermentationChangesetTriggerEnum;
/** Zod schema for fermentation_changeset_trigger_enum */
export const fermentationChangesetTriggerEnum = z.nativeEnum(FermentationChangesetTriggerEnum);
//# sourceMappingURL=FermentationChangesetTriggerEnum.js.map